import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LayoutSeoComponent } from './layout-seo.component';

@NgModule({
  declarations: [LayoutSeoComponent],
  imports: [CommonModule],
  exports: [LayoutSeoComponent],
})
export class LayoutSeoModule {}
